import React from 'react';

interface Props {
  children: React.ReactNode;
  onSubmit: () => void;
}

export const Form = ({ onSubmit, children }: Props) => {
  const handleSubmit = e => {
    e.preventDefault();
    onSubmit();
  };

  return <form onSubmit={handleSubmit}>{children}</form>;
};
